export default __webpack_public_path__ + "static/media/J.7f54f739.png";